/**
 * @typedef {import('./index.js').Store<State, Object>} Store
 */
/**
 * @template T
 * @template R
 * @typedef {import('./index.js').ActionFunction<T, R, State, Object>} ActionFunction<T,R>
 */
/**
 * @module Store:Overlay
 * @description Handles functionality for the overlay component
 */
export default {
  namespaced: true,
  /** Global State
   * @typedef {Object} State
   * @property {Array<string>} registeredOverlays - All registered overlays Id's
   * @property {boolean} waitingOverlay - If a overlay is set to active before it could register itself, it's ID is stored it in the waitingOverlay and as soon as it is registered it gets activated
   * @property {string} activeOverlay - Active overlay's ID
   */
  /** @type {State} */
  state: {
    registeredOverlays: [],
    waitingOverlay: null,
    activeOverlay: null
  },
  /** Mutations */
  mutations: {
    REGISTER_OVERLAY(state, overlayId) {
      if (state.registeredOverlays.includes(overlayId)) {
        throw new Error(`Overlay already registered with id ${overlayId}`)
      }
      state.registeredOverlays.push(overlayId)
      if (overlayId === state.waitingOverlay) {
        state.activeOverlay = state.waitingOverlay
        state.waitingOverlay = null
      }
    },
    MAKE_OVERLAY_ACTIVE(state, overlayId) {
      if (!state.registeredOverlays.includes(overlayId)) {
        state.waitingOverlay = overlayId
      } else {
        state.activeOverlay = overlayId
      }
    },
    CLEAR_OVERLAY(state) {
      state.activeOverlay = null
    }
  },
  /** Global Actions
   * @typedef {Object} Actions
   * @property {ActionFunction<string,void>} registerOverlay - Register an overlay ID, this function is runs in the <overlay> component mounted hook
   * @property {ActionFunction<string,void>} activateOverlay - Set a overlay active based on it's ID
   * @property {ActionFunction<string,void>} deactivateOverlay - Reset the active overlay
   */
  /** @type {Actions} */
  actions: {
    registerOverlay({ commit }, overlayId) {
      commit('REGISTER_OVERLAY', overlayId)
    },
    activateOverlay({ commit }, overlayId) {
      commit('MAKE_OVERLAY_ACTIVE', overlayId)
    },
    deactivateOverlay({ commit }) {
      commit('CLEAR_OVERLAY')
    },
  }
}